import { gutter, GutterMarker } from "@codemirror/view";
import { pageMarkerState } from "./pageNumbersGutter";
import { lintState } from "./lintState";
import { RangeSetBuilder } from "@codemirror/state";
import type { EditorView } from "@codemirror/view";

type Severity = "info" | "warning" | "error";

class CombinedGutterMarker extends GutterMarker {
  constructor(readonly pageIdx: number | null, readonly lintSeverity: Severity | null) {
    super();
  }

  toDOM() {
    const el = document.createElement("div");
    if (this.pageIdx !== null) {
      el.className = "qp-gutter-pageNumber";
      el.textContent = this.pageIdx.toString();
    } else if (this.lintSeverity) {
        // Use a container to center the marker dot
        el.className = "qp-lint-marker-container";
        const dot = document.createElement("div");
        dot.className = `cm-lint-marker cm-lint-marker-${this.lintSeverity}`;
        el.appendChild(dot);
    }
    return el;
  }
}

export const combinedGutter = gutter({
    class: "cm-page-numbers-gutter-gutter", // Use the same class to preserve styling
    markers(view: EditorView) {
        const pageMarkers = view.state.field(pageMarkerState);
        const lintDiagnostics = view.state.field(lintState);
        const builder = new RangeSetBuilder<GutterMarker>();

        // Add page number markers
        pageMarkers.between(0, view.state.doc.length, (from, to, marker) => {
            const pageMarker = marker as GutterMarker & { pageIdx: number };
            if (pageMarker.pageIdx) {
                builder.add(from, to, new CombinedGutterMarker(pageMarker.pageIdx, null));
            }
        });

        // Add lint markers
        for (const diagnostic of lintDiagnostics) {
            if (diagnostic.from !== -1) {
                const line = view.state.doc.lineAt(diagnostic.from);
                const severity = diagnostic.severity === "hint" ? "info" : diagnostic.severity;
                builder.add(line.from, line.from, new CombinedGutterMarker(null, severity));
            }
        }
        return builder.finish();
    },
    initialSpacer: () => new CombinedGutterMarker(null, null),
});
